import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashHomeComponent } from './dashboard/dash-home.component';
import { ProfileComponent } from './profile/profile.component';
import { AuthGuard } from './guards/auth.guard';
import { Utilities } from './shared/utilities.service';
import { AccounttransferComponent } from './accounttransfer/accounttransfer.component';
import { AccountdisbursementComponent } from './accountdisbursement/accountdisbursement.component';
import { PositionsContainerComponent } from './positions/positions-container.component';
import { PositionsComponent } from './positions/positions.component';
import { AccountactivityComponent } from './accountactivity/accountactivity.component';
import { DocumentsComponent } from './documents/documents.component';
import { ResetQuestionsComponent } from './login/reset-questions.component';
import { SignupComponent } from './signup/signup.component';
import { StandardDocumentComponent } from './documents/standard-document/standard-document.component';
import { DocummentscontainerComponent } from './documents/docummentscontainer/docummentscontainer.component';


const routes: Routes = [
    {
        path: '',
        component: LoginComponent
    },

    {     path: 'signup',
      component:SignupComponent

     },

    {

        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
        children: [
            {

                path: '',
                component: DashHomeComponent
                // path: '',
                // component: PositionsComponent
                
            },
            

            {
                path: 'account-setting',
                component: ProfileComponent
            },
            {
                path:'accounttransfer',
                component:AccounttransferComponent
            },
            {
                path:'accountdisbursement',
                component:AccountdisbursementComponent
            },
            {
                path: 'positions',
                component: PositionsContainerComponent,
                children: [
                    {
                        path: '',
                        component: PositionsComponent
        
                    },
                    {
                        path: 'summary',
                        component: PositionsComponent
        
                    },
                ]
            },
           
            {
                path:'accountactivity',
                component:AccountactivityComponent

            },
            //  {
            //      path:'documents',
            //      component:DocumentsComponent
            //  },
            // {
            //     path:'standarddocuments',
            //     component:StandardDocumentComponent
            // },

            {
                path:'documents',
                component:DocummentscontainerComponent,
                children:[
                    {
                        path: '',
                        redirectTo: 'memberdocuments',
                        pathMatch: 'full'
                    },
                    {
                        path:'memberdocuments',
                        component:DocumentsComponent
                    },
                    {
                        path:'standarddocuments',
                        component:StandardDocumentComponent
 
                    }
 
 
                ]
            }




           
        ]
    },
    {
        path: 'login',
        redirectTo: '',
        pathMatch: 'full'
    },
    {
        path: 'profile',
        component: ProfileComponent
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'set-security-questions', 
        component: ResetQuestionsComponent
        // canActivate: [AuthGuard],
    },
    {
        path: 'dashboard',
        component: DashboardComponent,
    },
];
// @NgModule({
//   imports: [ RouterModule.forRoot(routes) ],
//   exports: [ RouterModule ]
// })
// export class AppRoutingModule {}
export const routing = RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules });
 

